<template>
  <b-card>
  <div class="animated fadeIn">

    <!-- <b-row> -->
    <!-- <location-card :location='this.location'></location-card> -->
  <!-- </b-row> -->
    <div v-if="this.allowByHausType()">
        <div class="card-header">
          <ul class="nav nav-pills card-header-pills">

            <li class="nav-item">
              <a class="nav-link disabled">Managers</a>
            </li>
            <li class="nav-item">
              <div>
                <b-button @click="modalShow = !modalShow"  style="background-color:orange; color:#fff;">
                  <i class="fa fa-plus-circle"></i> Add
                </b-button>
                <b-modal :id="addManager" v-model="modalShow"  ok-only ok-variant="secondary" ok-title="Cancel">
                  <manager-add-form></manager-add-form>
                </b-modal>
              </div>
            </li>
          </ul>
        </div>
        <manager-list></manager-list>
    </div>
    <div v-if="!this.allowByHausType()">
      <b-card>
        <b-col sm="12" lg="12">
          <div class="alert alert-danger">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i>
                Current user <strong>may not</strong> access manager list.<br/>
                Please contact newport or owner.
              </li>
            </ul>
          </div>
        </b-col>
      </b-card>
    </div>
  </div>
</b-card>
</template>

<script>
// import LocationCard from '@/views/base/haus/LocationCard'
import ManagerList from '@/views/base/ManagerList'
import ManagerAddForm from '@/views/base/ManagerAddForm'
import ManagerForm from '@/views/base/ManagerForm'

let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
//const API = BASE + '/api/locations/simpleList'
// const API_DETAIL = BASE + '/api/locations/detail'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'access_token': data.access_token,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

// async function getLocation () {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     locationId: localStorage.getItem('locationId')
//   }
//   let res = await postdata(API_DETAIL, parameters)
//   if (!res.status.errCode || res.status.errCode === '422') {
//     localStorage.removeItem('locationId')
//     res = await postdata(API, parameters)
//     if (res.locations.length > 0) {
//       localStorage.setItem('locationId', res.locations[0].id)
//       return res.locations[0]
//     } else return res
//   } else {
//     return res.location
//   }
// }

export default {
  name: 'managers',
  components: {
    ManagerList,
    ManagerAddForm,
    ManagerForm
    // LocationCard
  },
  data: () => {
    return {
      modalShow: false
      // location: null
    }
  },
  props: ['addManager'],
  mounted () {
    // getLocation().then(response => {
    //   this.$data.location = response
    // })
    this.$root.$on('modalShow', (modalShow) => {
      this.modalShow = modalShow
    })
  },
  methods: {
    allowByHausType () {
      let haustype = localStorage.getItem('ouht')
      if (haustype == 1) {
        return true
      } else return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/Manager.vue